module.exports = __webpack_public_path__ + "img/logo-branca-main.e17c539b.png";